import { render, staticRenderFns } from "./DashboardBottomWidgets.vue?vue&type=template&id=62c504b3&scoped=true&"
import script from "./DashboardBottomWidgets.vue?vue&type=script&lang=js&"
export * from "./DashboardBottomWidgets.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBottomWidgets.vue?vue&type=style&index=0&id=62c504b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c504b3",
  null
  
)

component.options.__file = "DashboardBottomWidgets.vue"
export default component.exports